<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
                .form__field-body
                    cs-multiselect(
                        :options="difficulties"
                        v-model="params.difficult"
                        :placeholder="difficultLabel(params.difficult)"
                        :custom-label="difficultLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_visionFieldSpeed') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.speed"
                        :placeholder="secondsLabel(params.speed)"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            divider
            slot(name='parameters')
            .help-text
                slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import { cloneDeep } from 'lodash';
    import IntervalConfig from '../../trainer/configs/IntervalConfig';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data() {
            return {
                selectedDifficult: null,
                params: null,
                seconds: IntervalConfig.seconds,
            };
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(
                        item => item.slug === this.slug
                    ).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedDifficult = this.params.difficult;
        },
        updated() {
            this.selectedDifficult = this.params.difficult;
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            difficulties() {
                return [
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                        value: 2,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                        value: 3,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                        value: 4,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                        value: 5,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                        value: 6,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                        value: 7,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity8'),
                        value: 8,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity9'),
                        value: 9,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity10'),
                        value: 10,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity11'),
                        value: 11,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity12'),
                        value: 12,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity13'),
                        value: 13,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity14'),
                        value: 14,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity15'),
                        value: 15,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity16'),
                        value: 16,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity17'),
                        value: 17,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity18'),
                        value: 18,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity19'),
                        value: 19,
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_digitCapacity20'),
                        value: 20,
                    },
                ];
            },
        },
        methods: {
            difficultLabel(difficult) {
                return this.$i18n.t(`common.common_gameSetting_digitCapacity${difficult.value}`);
            },
            percentLabel(num) {
                return num + '%';
            },
            secondsLabel(second) {
                return second + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
    .help-text {
        text-align: center;
    }
</style>
